import { createAction, props } from '@ngrx/store';
import { ITask, ITaskCell } from '../../models/task.model';
import { IClipboardLogic } from '../../models/clipboard.model';
import { ITableVisualizationModel } from 'src/app/spa/models/table-visualization.model';
import { IReferenceDatasetResponse } from 'src/app/spa/models/spa-project.model';
import { RepeatPattern } from '../../models/repeat-logic.model';

export const ClearState = createAction('[Designer] Clear state');

export const SetTask = createAction('[Designer] Set task', props<{ task: ITask }>());
export const AddTlfs = createAction('[Designer] Add TLFs', props<{ tlfs: { name: string; index: number }[] }>());
export const SetReferenceTlf = createAction(
  '[Designer] Set reference tlf',
  props<{ tlf: { name: string; index: number } }>()
);
export const SetCell = createAction('[Designer] Set cell', props<{ cell: ITaskCell }>());
export const SetReferenceCell = createAction('[Designer] Set reference cell', props<{ cell: ITaskCell }>());
export const AddCells = createAction('[Designer] Add cells', props<{ cells: ITaskCell[] }>());
export const SetCells = createAction('[Designer] Set cells', props<{ cells: ITaskCell[] }>());
export const RemoveCells = createAction('[Designer] Remove cells', props<{ cells: ITaskCell[] }>());
export const SetDescription = createAction('[Designer] Set description', props<{ description: string }>());
export const ClearCells = createAction('[Designer] Clear cells');

export const SetClipboard = createAction(
  '[Designer] Set clipboard',
  props<{ cell?: ITaskCell; logics?: IClipboardLogic[] }>()
);
export const ClearClipboard = createAction('[Designer] Clear clipboard');

export const GetReferenceTable = createAction(
  '[Designer] Get reference table',
  props<{ projectID: string; checkKey: string; fileName?: string; tableIndex?: number }>()
);

export const GetReferenceTableSuccess = createAction(
  '[Designer] Get reference table success',
  props<{ payload: ITableVisualizationModel[] | IReferenceDatasetResponse }>()
);

export const GetReferenceTableFailed = createAction('[Designer] Get reference table failed', props<{ payload: Error }>());
export const EnableRepeat = createAction('[Designer] Enable repeat');
export const DisableRepeat = createAction('[Designer] Disable repeat');

export const UpdateRepeat = createAction(
  '[Designer] Set update repeat',
  props<{ repeat: { horizontal: RepeatPattern; vertical: RepeatPattern } }>()
);
